<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="sealRingNumber_toolTip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Seal Ring Number -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.SEAL_RING_NUMBER' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #sealRingNumber_toolTip>
        <ng-container *transloco="let t; read: 'TOOLTIP.INFORMATE_CALC_LABELS.SEAL_RING_NUMBER'">
            <p>
                {{ t('FIRST_PARAGRAPH') }}
            </p>
            <p>
                {{ t('SECOND_PARAGRAPH') }}
            </p>
        </ng-container>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="sealRingNumber"
        name="sealRingNumber"
        class="input-select"
        [class.spinner]="loading"
        [class.select-disable]="enable"
        (selectionChange)="selectSealRing($event)"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.sealRingId">{{ x.ringSize }}</mat-option>
    </mat-select>
</div>
